"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _util = require("./util");

var _createStore = _interopRequireDefault(require("../createStore"));

var _Provider = _interopRequireDefault(require("../Provider"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var COLLECTION_EVENTS = 'add change remove reset';
var MODEL_EVENTS = 'change';

var EnhancedComponent =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(EnhancedComponent, _Component);

  function EnhancedComponent(_props) {
    var _this = _Component.call(this, _props) || this;

    _this.renderStateComponent = function () {
      var component = _this.props.component;

      var props = _extends({}, _this.state);

      if (_react.default.isValidElement(component)) {
        return _react.default.cloneElement(component, props);
      } else {
        return _react.default.createElement(component, props);
      }
    };

    var componentProps = _props.component.props,
        initialState = _props.initialState,
        externalActions = _props.externalActions;
    _this.state = (0, _util.transformDataToProps)(componentProps);
    _this.stateCollections = (0, _util.getCollections)(componentProps);
    _this.stateModels = (0, _util.getModels)(componentProps);
    _this.store = (0, _createStore.default)(initialState, externalActions);
    _this.watchAll = (0, _util.makeWatchAll)(_this.updateState, _assertThisInitialized(_this));
    return _this;
  }

  var _proto = EnhancedComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.watchState();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unwatchState();
  };

  _proto.render = function render() {
    return _react.default.createElement(_Provider.default, {
      store: this.store
    }, this.renderStateComponent());
  };

  _proto.updateState = function updateState() {
    var props = (0, _util.transformDataToProps)(this.props.component.props);
    this.setState(_extends({}, props));
  };

  _proto.unwatchState = function unwatchState() {
    this.watchAll.off(this.stateCollections, COLLECTION_EVENTS);
    this.watchAll.off(this.stateModels, MODEL_EVENTS);
  };

  _proto.watchState = function watchState() {
    this.watchAll.on(this.stateCollections, COLLECTION_EVENTS);
    this.watchAll.on(this.stateModels, MODEL_EVENTS);
  };

  return EnhancedComponent;
}(_react.Component);

EnhancedComponent.defaultProps = {
  initialState: {},
  externalActions: {}
};
EnhancedComponent.displayName = 'BrigadeEnhancedComponent';
process.env.NODE_ENV !== "production" ? EnhancedComponent.propTypes = {
  component: _propTypes.default.oneOfType([_propTypes.default.element.isRequired, _propTypes.default.func]),
  initialState: _propTypes.default.object,
  externalActions: _propTypes.default.object
} : void 0;
var _default = EnhancedComponent;
exports.default = _default;